import * as angular from 'angular';
import LibraryDraftsGridBridge from './LibraryDraftsGridBridge';

angular
  .module('flowingly.runner.library')
  .component('libraryDraftsGrid', LibraryDraftsGridBridge);
